import React from 'react';
import {
  Icon,
  IconButton,
  TableCell,
  TableRow,
} from '@material-ui/core';


const QuoteMarketingSegmentsItem = ({key, segment, handleEdit, handleDeleteMarketingSegment}) => {
  return (
    <TableRow key={key}>
      <TableCell>{segment.label}</TableCell>
      <TableCell align="right">
        <IconButton
          size="medium"
          onClick={handleEdit}
        >
          <Icon fontSize="small">edit</Icon>
        </IconButton>
        <IconButton
          size="medium"
          onClick={() => handleDeleteMarketingSegment(segment.value)}
        >
          <Icon fontSize="small">delete</Icon>
        </IconButton>
      </TableCell>
    </TableRow>
  );
};

export default QuoteMarketingSegmentsItem;
